import {
  alignContent,
  AlignContentProps,
  alignItems,
  AlignItemsProps,
  alignSelf,
  AlignSelfProps,
  justifyContent,
  JustifyContentProps,
  justifySelf,
  JustifySelfProps,
} from 'styled-system';
import { css } from '~ui-kit/styled-components';
import { applyTransientProps, PrependDollar } from './styled-system-helpers';

/**
 * align, align-items
 */
export type StyledAlignItemsProps = PrependDollar<AlignItemsProps>;

export const styledAlignItems = <T extends StyledAlignItemsProps>(props: T) => applyTransientProps(props, alignItems);

/**
 * align-content
 */
export type StyledAlignContentProps = PrependDollar<AlignContentProps>;

export const styledAlignContent = <T extends StyledAlignContentProps>(props: T) =>
  applyTransientProps(props, alignContent);

/**
 * justify, justify-content
 */
export type StyledJustifyContentProps = PrependDollar<JustifyContentProps>;

export const styledJustifyContent = <T extends StyledJustifyContentProps>(props: T) =>
  applyTransientProps(props, justifyContent);

/**
 * align-self
 */
export type StyledAlignSelfProps = PrependDollar<AlignSelfProps>;

export const styledAlignSelf = <T extends StyledAlignSelfProps>(props: T) => applyTransientProps(props, alignSelf);

/**
 * justify-self
 */
export type StyledJustifySelfProps = PrependDollar<JustifySelfProps>;

export const styledJustifySelf = <T extends StyledJustifySelfProps>(props: T) =>
  applyTransientProps(props, justifySelf);

/**
 * Combine align items, align content and justify content
 */
export interface StyledChildPositioningProps
  extends StyledAlignItemsProps,
    StyledAlignContentProps,
    StyledJustifyContentProps {}

export const styledChildPositioning = css<StyledChildPositioningProps>`
  ${styledAlignItems}
  ${styledAlignContent}
  ${styledJustifyContent}
`;

/**
 * Combine align self and justify self
 */
export interface StyledSelfPositioningProps extends StyledAlignSelfProps, StyledJustifySelfProps {}

export const styledSelfPositioning = css<StyledSelfPositioningProps>`
  ${styledAlignSelf}
  ${styledJustifySelf}
`;
